var map = {
	"./en.json": "./locales/resources/en.json",
	"./nb-x-ap.json": "./locales/resources/nb-x-ap.json",
	"./nb-x-bt.json": "./locales/resources/nb-x-bt.json",
	"./nb-x-e24.json": "./locales/resources/nb-x-e24.json",
	"./nb-x-sa.json": "./locales/resources/nb-x-sa.json",
	"./nb-x-sno.json": "./locales/resources/nb-x-sno.json",
	"./nb-x-vg.json": "./locales/resources/nb-x-vg.json",
	"./nb-x-vkno.json": "./locales/resources/nb-x-vkno.json",
	"./nb.json": "./locales/resources/nb.json",
	"./sv-x-ab.json": "./locales/resources/sv-x-ab.json",
	"./sv-x-omni.json": "./locales/resources/sv-x-omni.json",
	"./sv-x-sse.json": "./locales/resources/sv-x-sse.json",
	"./sv-x-svd.json": "./locales/resources/sv-x-svd.json",
	"./sv-x-wellobe.json": "./locales/resources/sv-x-wellobe.json",
	"./sv.json": "./locales/resources/sv.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./locales/resources sync recursive ^\\.\\/.*\\.json$";